import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { auth, db } from '../config/firebaseConfig'

/**
 * One promo list for new products and promotions.
 * `newsletter/{emailId}` is the mailing list. `users.agreePromoMaterials` is the
 * same consent on an account when the visitor is signed in.
 */
export const newsletterDocId = (email: string): string =>
  email.trim().toLowerCase().replace(/@/g, '_at_').replace(/\./g, '_dot_')

export async function subscribeToNewsletter({
  email,
  language,
  source,
}: {
  email: string
  language: string
  source: string
}): Promise<void> {
  const normalizedEmail = email.trim().toLowerCase()
  if (!normalizedEmail) {
    throw new Error('Email is required')
  }

  await setDoc(
    doc(db, 'newsletter', newsletterDocId(normalizedEmail)),
    {
      email: normalizedEmail,
      consent: true,
      newProducts: true,
      promotions: true,
      language,
      source,
      updatedAt: serverTimestamp(),
      createdAt: serverTimestamp(),
    },
    { merge: true }
  )

  const uid = auth.currentUser?.uid
  if (!uid) {
    return
  }

  try {
    await setDoc(doc(db, 'users', uid), { agreePromoMaterials: true }, { merge: true })
  } catch (error) {
    console.error('Could not update user promo consent:', error)
  }
}
